import { motion } from "framer-motion";
import { ABOUT_IMG } from "@/data/content";
import { easeOutExpo, fadeUp } from "@/lib/motion";

const VALUES = ["Eco-friendly materials", "Local artisan collectives", "Bespoke customization", "Pan-India express delivery"];

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 lg:py-32 bg-sand/60 border-y border-gold/20 scroll-mt-16" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <motion.div {...fadeUp}>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-crimson" data-testid="about-eyebrow">
              About Our Atelier
            </p>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-charcoal leading-[1.08]" data-testid="about-heading">
              A little house of gifts,
              <span className="italic text-terracotta"> from A to Z</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-clay" data-testid="about-para-1">
              A to Z Gift and Craft House began with a simple belief: a gift
              should feel personal — not picked off a shelf. Every box we send
              is curated for one person, one occasion, one story.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-clay" data-testid="about-para-2">
              We work with local artisans and eco-friendly materials to bring
              traditional Indian craftsmanship into modern, premium gifting —
              and we customize absolutely everything, down to the ribbon.
            </p>
          </motion.div>

          <motion.ul {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.15 }} className="mt-9 flex flex-wrap gap-3" data-testid="about-values">
            {VALUES.map((v) => (
              <li
                key={v}
                className="rounded-full border border-gold/40 bg-ivory px-5 py-2.5 text-[13px] font-semibold text-charcoal/80"
                data-testid={`about-value-${v.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {v}
              </li>
            ))}
          </motion.ul>
        </div>

        <motion.div
          {...fadeUp}
          className="lg:col-span-5 order-1 lg:order-2"
        >
          <div className="relative mx-auto max-w-[460px]">
            <div className="hidden sm:block absolute -inset-4 rounded-[28px] border border-gold/35 translate-x-4 translate-y-4" aria-hidden="true" />
            <div className="relative rounded-[24px] overflow-hidden shadow-[0_50px_100px_-45px_rgba(26,21,18,0.55)]">
              <img
                src={ABOUT_IMG}
                alt="Hands crafting paper gifts at the A to Z atelier"
                className="img-warm w-full h-[380px] sm:h-[460px] object-cover"
                loading="lazy"
                data-testid="about-image"
              />
              <div className="absolute inset-0 bg-[radial-gradient(85%_65%_at_50%_0%,rgba(250,247,242,0.15),transparent_60%)]" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
